import React from 'react';

export function DiningIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6 10V2v6m0 2v7.999m0-8c-2 0-4-1-4-4V2m8 0v6a2 2 0 1 0 4 0V2"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M13.998 10v8"
      />
    </svg>
  );
}
